@if (showConfirmRemovePoolDialog || showQuestionPoolInfoDialog) {
  <div class="fixed w-screen h-screen bg-gray-600 top-0 bottom-0 left-0 right-0 overflow-hidden bg-opacity-60 z-30">
    <div class="h-full w-full flex justify-center items-center">
      @if (showConfirmRemovePoolDialog) {
        <app-delete-confirmation
          [message]="'Are you sure you want to remove this question pool?'"
          (cancel)="showConfirmRemovePoolDialog = false"
          (confirm)="removePool()"
        ></app-delete-confirmation>
      } @else if (showQuestionPoolInfoDialog) {
        <div class="items-center justify-center rounded-[16px] bg-white p-3 absolute text-zinc-500 text-center max-w-[750px] overflow-y-hidden">
          <div class="flex justify-between items-center mb-2 gap-1">
            <div class="font-bold">
              Question Pool Information
            </div>
            <button aria-label="Close" (click)="showQuestionPoolInfoDialog  = false" class="mr-1 text-zinc-500 rounded-full py-1 px-2 hover:bg-gray-200">
              <fa-icon [icon]="faXmark" />
            </button>
          </div>
          <div class="text-left p-3">
            A <b>question pool</b> is a collection of questions used to build an exam (or an exam section). You can
            create as many question pools as needed.
            <br/><br/>
            Typically, the number of questions in a pool matches the value set in “<b>Questions Used per Pool.</b>”
            For example, if an exam section requires 5 questions, you have two common options:
            <ul class="ml-8">
              <li><b>Option 1: One pool with 5 questions,</b> and set Questions Used per Pool to 5</li>
              <li><b>Option 2: Five pools with 1 question each,</b> and set Questions Used per Pool to 1 for each pool</li>
            </ul>
            <br/>
            In both cases, the student will receive 5 total questions for that section.
            If you want to introduce randomness, you can add more questions to a pool than are used on the exam.
            For example, if an exam section requires 5 questions:
            <ul class="list-disc ml-8">
              <li>Create <b>one question pool</b></li>
              <li>Set <i>Questions Used per Pool</i> to <b>5</b></li>
              <li>Add <b>10 questions</b> to the pool</li>
            </ul>
            When the exam is generated, the system will randomly select <b>5 questions from the 10</b> for each student.
            This allows you to vary the questions students receive while keeping the exam structure consistent.
          </div>
        </div>
      }
    </div>
  </div>
}

<div [formGroup]="part" class="flex-col border border-[#74808B] rounded-[8px] items-center text-[#424D57] min-h-[600px]">
  <button aria-label="Collapse" (click)="part.get('expanded')?.setValue(false)" class="flex items-center flex-grow w-full hover:bg-gray-200 px-[14px] py-[8px] rounded-t-[8px]">
    <fa-icon [icon]="faChevronUp" />
    <div class="ml-[22px] py-[5px]">
      {{part.get('part_name')?.value}}
    </div>
  </button>
  <div class="px-[14px] py-[8px]">
    @if (qpools.length === 0) {
      <div class="h-[400px] flex flex-col justify-center items-stretch">
        <div class="flex justify-center gap-1">
          <div class="flex justify-center">
            <full-button (click)="addNewPool(part_index)" text="Add Question Pool" />
          </div>
          <button (click)="showQuestionPoolInfoDialog = true" class="flex justify-center items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M6 8.5C6.14167 8.5 6.2605 8.452 6.3565 8.356C6.4525 8.26 6.50033 8.14133 6.5 8V6C6.5 5.85833 6.452 5.73967 6.356 5.644C6.26 5.54833 6.14133 5.50033 6 5.5C5.85867 5.49967 5.74 5.54767 5.644 5.644C5.548 5.74033 5.5 5.859 5.5 6V8C5.5 8.14167 5.548 8.2605 5.644 8.3565C5.74 8.4525 5.85867 8.50033 6 8.5ZM6 4.5C6.14167 4.5 6.2605 4.452 6.3565 4.356C6.4525 4.26 6.50033 4.14133 6.5 4C6.49967 3.85867 6.45167 3.74 6.356 3.644C6.26033 3.548 6.14167 3.5 6 3.5C5.85833 3.5 5.73967 3.548 5.644 3.644C5.54833 3.74 5.50033 3.85867 5.5 4C5.49967 4.14133 5.54767 4.26017 5.644 4.3565C5.74033 4.45283 5.859 4.50067 6 4.5ZM6 11C5.30833 11 4.65833 10.8687 4.05 10.606C3.44167 10.3433 2.9125 9.98717 2.4625 9.5375C2.0125 9.08783 1.65633 8.55867 1.394 7.95C1.13167 7.34133 1.00033 6.69133 1 6C0.999667 5.30867 1.131 4.65867 1.394 4.05C1.657 3.44133 2.01317 2.91217 2.4625 2.4625C2.91183 2.01283 3.441 1.65667 4.05 1.394C4.659 1.13133 5.309 1 6 1C6.691 1 7.341 1.13133 7.95 1.394C8.559 1.65667 9.08817 2.01283 9.5375 2.4625C9.98683 2.91217 10.3432 3.44133 10.6065 4.05C10.8698 4.65867 11.001 5.30867 11 6C10.999 6.69133 10.8677 7.34133 10.606 7.95C10.3443 8.55867 9.98817 9.08783 9.5375 9.5375C9.08683 9.98717 8.55767 10.3435 7.95 10.6065C7.34233 10.8695 6.69233 11.0007 6 11Z" fill="#74808B"/>
            </svg>
          </button>
        </div>
      </div>
    }
    @if (qpools.length !== 0) {
      <div class="mt-[24px]">
        @for (pool of qpools.controls; track pool; let x = $index) {
          <div class="rounded-[8px] border border-[#74808B] pb-[21px] mt-[15px]">
            <div class="flex justify-between bg-[#F6F7F8] p-[10px] rounded-[8px]">
              <button aria-label="Toggle Expand" (click)="pool.get('expanded')?.setValue(!pool.get('expanded')?.value)" class="flex flex-grow">
                @if (pool.get('expanded')?.value) {
                  <fa-icon [icon]="faChevronUp" />
                }
                @if (!pool.get('expanded')?.value) {
                  <fa-icon [icon]="faChevronDown" />
                }
                <div class="text-14px ml-[10px]">
                  Pool {{x+1}}
                </div>
              </button>
              <button (click)="showConfirmRemovePool(x, qpools)" class="hover:bg-gray-200 rounded-full w-[24px] h-[24px]" aria-label="Remove Question Pool">
                <fa-icon [icon]="faXmark" />
              </button>
            </div>
            @if (pool.get('expanded')?.value) {
              <div class="ml-[12px]">
                <div class="text-[12px] mt-[8px]">
                  You can add multiple questions and hence multiple problem templates in this pool.
                </div>
                <div class="text-[12px] mt-[8px]">
                  Every question within the pool should have the same points value.
                </div>
                <div class="ml-[10px] mt-[24px] grid grid-cols-2">
                  <div class="flex items-center">
                    <input (change)="scoreChange($event, pool)" [value]="pool.get('score_per_question')?.value" type="number" placeholder="Enter Value" class="bg-[#F6F7F8] rounded-[4px] px-[10px] py-[8px] mr-[7px] noOutlineInput"/>
                    <p class="text-[14px]">Score per question</p>
                  </div>
                  <div class="flex items-center justify-end mr-3">
                    <input (change)="questionsUsedChange($event, pool)" [value]="pool.get('questions_used')?.value" type="number" placeholder="Enter Value" class="bg-[#F6F7F8] rounded-[4px] px-[10px] py-[8px] mr-[7px] noOutlineInput" min="1" />
                    <p>Questions used per pool</p>
                  </div>
                </div>
                <pool-question [problemTemplates]="allProblemTemplates" [(allSubjectsAdded)]="allSubjectsAdded" [(addedLearningObjective)]="addedLearningObjective" [index]="x" formGroupName="qpools"></pool-question>
              </div>
            }
          </div>
        }
        <div class="my-5 flex justify-center gap-1">
          <button (click)="addNewPool(part_index)" class="rounded-[4px] border border-[#A2ADB9] hover:bg-gray-200 px-[16px] py-[6px]">
            Add Question Pool
          </button>
          <button (click)="showQuestionPoolInfoDialog = true" class="flex justify-center items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M6 8.5C6.14167 8.5 6.2605 8.452 6.3565 8.356C6.4525 8.26 6.50033 8.14133 6.5 8V6C6.5 5.85833 6.452 5.73967 6.356 5.644C6.26 5.54833 6.14133 5.50033 6 5.5C5.85867 5.49967 5.74 5.54767 5.644 5.644C5.548 5.74033 5.5 5.859 5.5 6V8C5.5 8.14167 5.548 8.2605 5.644 8.3565C5.74 8.4525 5.85867 8.50033 6 8.5ZM6 4.5C6.14167 4.5 6.2605 4.452 6.3565 4.356C6.4525 4.26 6.50033 4.14133 6.5 4C6.49967 3.85867 6.45167 3.74 6.356 3.644C6.26033 3.548 6.14167 3.5 6 3.5C5.85833 3.5 5.73967 3.548 5.644 3.644C5.54833 3.74 5.50033 3.85867 5.5 4C5.49967 4.14133 5.54767 4.26017 5.644 4.3565C5.74033 4.45283 5.859 4.50067 6 4.5ZM6 11C5.30833 11 4.65833 10.8687 4.05 10.606C3.44167 10.3433 2.9125 9.98717 2.4625 9.5375C2.0125 9.08783 1.65633 8.55867 1.394 7.95C1.13167 7.34133 1.00033 6.69133 1 6C0.999667 5.30867 1.131 4.65867 1.394 4.05C1.657 3.44133 2.01317 2.91217 2.4625 2.4625C2.91183 2.01283 3.441 1.65667 4.05 1.394C4.659 1.13133 5.309 1 6 1C6.691 1 7.341 1.13133 7.95 1.394C8.559 1.65667 9.08817 2.01283 9.5375 2.4625C9.98683 2.91217 10.3432 3.44133 10.6065 4.05C10.8698 4.65867 11.001 5.30867 11 6C10.999 6.69133 10.8677 7.34133 10.606 7.95C10.3443 8.55867 9.98817 9.08783 9.5375 9.5375C9.08683 9.98717 8.55767 10.3435 7.95 10.6065C7.34233 10.8695 6.69233 11.0007 6 11Z" fill="#74808B"/>
            </svg>
          </button>
        </div>
      </div>
    }
  </div>
</div>
